'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'mug-saucer';
var width = 640;
var height = 512;
var aliases = ["coffee"];
var unicode = 'f0f4';
var svgPathData = ['M0 416l32 0 512 0 32 0 0 64-32 0L32 480 0 480l0-64z', 'M448 32L96 32l0 352 384 0 0-96 32 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-32 0-32 0zm32 64l32 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-32 0 0-128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMugSaucer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;